export const ON_CHANNEL_MESSAGES = 'OnChannelMessages';
export const ON_NEW_LAST_POINTS = 'OnNewLastPoints';
export const ON_REPORT_BUILD_PROGRESS = 'OnReportBuildProgress';
export const ON_SEND_ALERTS_CAUSE = 'OnSendAlertsCause';
export const ON_SEND_ALERTS_APPROVE = 'OnSendAlertsApprove';
export const ON_NAV_OBJECT_ADDED = 'OnNavObjectAdded';
export const ON_NAV_OBJECT_CHANGED = 'OnNavObjectChanged';
export const ON_NAV_OBJECT_REMOVED = 'OnNavObjectRemoved';
export const ON_ALERT_RESPONDED = 'OnAlertResponded';